"use strict";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";

import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import { Box, Button, Flex, Grid, Group, Input, MultiSelect, MultiSelectProps, Select, Tabs, Text } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDebouncedCallback, useDisclosure } from "@mantine/hooks";
import { IconBarcode, IconBrandBootstrap, IconBuildingFactory, IconCalendarStats, IconChartBar, IconChartDonut3, IconSearch, IconSortAscendingShapes, IconTable, IconTimeDuration15 } from "@tabler/icons-react";
import { AgChartOptions } from "ag-charts-enterprise";
import { AgCharts } from "ag-charts-react";
import {
  ColDef,
  GridReadyEvent,
  ModuleRegistry
} from "ag-grid-community";
import {
  IServerSideDatasource,
  IServerSideGetRowsRequest,
  ServerSideRowModelModule
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { paginationPageSize, paginationPageSizeSelector, repositoryDelivery, repositoryPos } from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { formatPrice } from "../../../common/formatPrice/PriceFunction";
import LoadingOverlayCustom from "../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { MessageResponse } from "../../../model/MessageResponse";

ModuleRegistry.registerModules([
  ServerSideRowModelModule
]);
export interface SumListSerialQKModel {
  OrganizationId: number;
  OrgCode: string;
  ItemCode: string;

  SlTonDauTong: number;
  GtTonDauTong: number;

  SlTonCuoiTong: number;
  GtTonCuoiTong: number;
}

const SumListSerialQKV2 = () => {
  const [loading, setLoading] = useState(true);
  const gridRef = useRef<AgGridReact<any>>(null);
  const datasourceRef = useRef<IServerSideDatasource | null>(null);
  const [dataItemCode, setDataItemCode] = useState<any[]>([]);

  const [selectedPeriod, setSelectedPeriod] = useState<string | null>();
  const [periodOptions, setPeriodOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [height, setHeight] = useState(800);
  const [dataBranchCode, setDataBranchCode] = useState<SelectListItemBase[]>([]);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [dataPositionCode, setDataPositionCode] = useState<
    SelectListItemBase[]
  >([]);
  // Chỗ này để làm lọc dùng form cho đỡ lag so với state
  // Những tham số comment là những tham số chưa cần truyền , những tham số truyền nhưng không hiển thị là theo yêu cầu (vì cần truy vấn dữ liệu)
  const now = new Date();
  const currentYear = now.getFullYear();

  const form = useForm<any>({
    initialValues: {
      OrgCode: null,        // array[string] //Mã chi nhánh
      SubInvCode: null,        // array[string] //Mã vị trí
      ItemCode: null,          // array[string] //mã sản phẩm
      TimeType: "date",        // date, month, quarter , year
      LoaiKy: "NGAY", // Đặt mặc định là "NAM"
      startDate: formatLocalDate(
        new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      ), // Ngày 01 của tháng hiện tại
      endDate: formatLocalDate(
        new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
      ), // Ngày cuối cùng của tháng hiện tại
      KeySearch: null,       // string
      Tabs: 'table', // table, chartColumn, chartPie
      Year: String(currentYear),
    },
  });

  // Cho hình cột
  const ChartColumnRef = useRef<HTMLDivElement>(null);
  // Cho hình tròn
  const ChartPieRef = useRef<HTMLDivElement>(null);

  const containerStyle = useMemo(() => ({ width: "100%", height: `${height}px` }), [height]);
  const gridStyle = useMemo(() => ({ height: `${height + 90}px `, width: "100%" }), [height]);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 2, xl: 1.7 };

  // Chart data state
  const [chartData, setChartData] = useState<any[]>([]);
  const chartOptions = useMemo<AgChartOptions>(() => {
    const view = form.getValues().view;
    const isGiatri = view === "giatri" || view === "giatri_cuoi";
    return {
      autoSize: true,
      theme: "ag-default",
      title: {
        text: isGiatri ? `Tổng giá trị tồn kho theo chi nhánh` : `Tổng số lượng tồn kho theo chi nhánh`,
        fontSize: 22,
        color: '#000',
      },
      subtitle: {
        text: isGiatri ? `Đơn vị: VND` : `Đơn vị: Số lượng`,
        color: '#000',
      },
      data: chartData,
      series: [
        {
          type: 'bar' as const,
          direction: 'horizontal',
          xKey: 'branch',
          yKey: 'value',
          yName: isGiatri ? 'Tổng giá trị' : 'Tổng số lượng',
          fill: '#4dabf7',
          stroke: '#228be6',
          cornerRadius: 4,
          label: {
            enabled: true,
            color: '#000',
            fontSize: 13,
            placement: 'outside-end',
            formatter: ({ value }: any) => isGiatri ? formatPrice(value) : String(value),
            marginLeft: 10
          },
        },
      ],
      axes: [
        {
          type: 'category',
          position: 'left',
          label: {
            color: '#000',
            maxWidth: 500,
            width: 500,
            autoRotate: false
          }
        },
        {
          type: 'number',
          position: 'bottom',
          title: { text: isGiatri ? 'Giá trị' : 'Số lượng', color: '#000' },
          label: {
            formatter: (params: any) => isGiatri ? formatPrice(params.value) : String(params.value),
            color: '#000',
          },
          gridLine: {
            style: [{ stroke: '#2c3340', lineDash: [4, 4] }],
          },
        },
      ],
      legend: { enabled: false },
      padding: { top: 20, right: 60, bottom: 20, left: 20 },
    }
  }, [chartData, form.getValues().view]);

  // Chart Pie Options
  const pieOptions = useMemo<AgChartOptions>(() => {
    const view = form.getValues().view;
    const isGiatri = view === "giatri" || view === "giatri_cuoi";
    return {
      autoSize: true,
      theme: "ag-default",
      title: {
        text: isGiatri ? `Tỷ trọng theo tổng giá trị theo chi nhánh` : `Tỷ trọng theo tổng số lượng theo chi nhánh`,
        fontSize: 22,
        color: '#000',
      },
      data: chartData,
      series: [
        {
          type: 'pie',
          angleKey: 'value',
          legendItemKey: 'branch',
          calloutLabelKey: 'branch',
          sectorLabelKey: 'value',
          calloutLabel: {
            enabled: true,
            color: '#000',
            fontSize: 12,
            offset: 10,
          },
          calloutLine: {
            strokeWidth: 1,
            colors: ['#000'],
          },
          tooltip: {
            renderer: ({ datum }: any) =>
              `${datum.branch} — ${isGiatri ? formatPrice(datum.value) : datum.value}`
          },
        },
      ],
      highlightStyle: {
        item: {
          strokeWidth: 5,
        },
        series: {
          opacity: 0.2,
        },
      },
      legend: {
        position: 'bottom',
        item: {
          label: {
            color: '#000',
          },
          paddingX: 20
        },
      },
      padding: { top: 20, right: 20, bottom: 20, left: 20 },
    } as AgChartOptions;
  }, [chartData, form.getValues().view]);

  useEffect(() => {
    const updateHeight = () => {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      // 400 là tổng khoảng cách cần trừ (breadcrumb, filters, padding, pagination)
      const newHeight = window.innerHeight - (210 + headerHeight);
      setHeight(newHeight);
    };

    // Đợi DOM render xong rồi mới tính
    setTimeout(updateHeight, 0);
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);


  // Hàm tự động set ngày theo loại kỳ
  const handleLoaiKyChange = useCallback(
    (value: string | null) => {
      form.setFieldValue("LoaiKy", value ?? "NGAY");
      setSelectedPeriod(null);

      const now = new Date();
      const yearFromForm = form.getValues().Year || now.getFullYear();
      let startDate: Date;
      let endDate: Date;
      let options: { value: string; label: string }[] = [];

      switch (value) {
        case "NGAY":
          startDate = now;
          endDate = now;
          break;

        case "THANG":
          for (let i = 0; i < 12; i++) {
            options.push({ value: String(i + 1), label: `Tháng ${i + 1}` });
          }
          setPeriodOptions(options);
          startDate = new Date(yearFromForm, now.getMonth(), 1);
          endDate = new Date(yearFromForm, now.getMonth() + 1, 0);
          setSelectedPeriod(String(now.getMonth() + 1));
          break;

        case "QUY":
          options.push(
            { value: "1", label: "Quý 1 (Tháng 1-3)" },
            { value: "2", label: "Quý 2 (Tháng 4-6)" },
            { value: "3", label: "Quý 3 (Tháng 7-9)" },
            { value: "4", label: "Quý 4 (Tháng 10-12)" }
          );
          setPeriodOptions(options);
          const currentMonth = now.getMonth();
          const quarter = Math.floor(currentMonth / 3) + 1;
          setSelectedPeriod(String(quarter));
          const quarterStartMonth = (quarter - 1) * 3;
          startDate = new Date(yearFromForm, quarterStartMonth, 1);
          endDate = new Date(yearFromForm, quarterStartMonth + 3, 0);
          break;

        case "NAM":
          for (let i = 0; i < 5; i++) {
            const year = now.getFullYear() - i;
            options.push({ value: String(year), label: `Năm ${year}` });
          }
          setPeriodOptions(options);
          startDate = new Date(yearFromForm, 0, 1);
          endDate = new Date(yearFromForm, 11, 31);
          setSelectedPeriod(String(yearFromForm));
          break;

        default:
          startDate = now;
          endDate = now;
      }

      form.setFieldValue("startDate", formatLocalDate(startDate));
      form.setFieldValue("endDate", formatLocalDate(endDate));
    },
    [form]
  );

  const handlePeriodSelectChange = useCallback(
    (value: string | null) => {
      setSelectedPeriod(value);
      const loaiKy = form.getValues().LoaiKy;
      const now = new Date();
      const yearFromForm = form.getValues().Year || now.getFullYear();
      let startDate: Date;
      let endDate: Date;

      if (!value) return;

      switch (loaiKy) {
        case "THANG":
          const month = parseInt(value, 10) - 1;
          startDate = new Date(yearFromForm, month, 1);
          endDate = new Date(yearFromForm, month + 1, 0);
          break;
        case "QUY":
          const quarter = parseInt(value, 10);
          const quarterStartMonth = (quarter - 1) * 3;
          startDate = new Date(yearFromForm, quarterStartMonth, 1);
          endDate = new Date(yearFromForm, quarterStartMonth + 3, 0);
          break;
        case "NAM":
          const year = parseInt(value, 10);
          startDate = new Date(year, 0, 1);
          endDate = new Date(year, 11, 31);
          break;
        default:
          return;
      }

      form.setFieldValue("startDate", formatLocalDate(startDate));
      form.setFieldValue("endDate", formatLocalDate(endDate));
    },
    [form]
  );
  // New extracted function: xử lý khi chọn năm (dùng cho THANG/QUY/NAM)
  const handleYearChange = useCallback(
    (v: string | null) => {
      if (!v) return;
      const year = parseInt(v, 10);
      form.setFieldValue("Year", year);
      const loaiKy = form.getValues().LoaiKy;
      const period = selectedPeriod;
      let startDate: Date;
      let endDate: Date;

      if (loaiKy === "THANG") {
        const month = period ? parseInt(period, 10) - 1 : new Date().getMonth();
        startDate = new Date(year, month, 1);
        endDate = new Date(year, month + 1, 0);
      } else if (loaiKy === "QUY") {
        const quarter = period ? parseInt(period, 10) : 1;
        const quarterStartMonth = (quarter - 1) * 3;
        startDate = new Date(year, quarterStartMonth, 1);
        endDate = new Date(year, quarterStartMonth + 3, 0);
      } else {
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 11, 31);
      }

      form.setFieldValue("startDate", formatLocalDate(startDate));
      form.setFieldValue("endDate", formatLocalDate(endDate));
    },
    [form, selectedPeriod]
  );
  function formatLocalDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }


  // Lấy danh sách chi nhánh
  const fetchBranchCode = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<SelectListItemBase[]>
      >(`api/v1/TblDmInventory/get-select-branch?auth=true`);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCode(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Lấy danh sách vị trí
  const fetchPositionCode = async () => {
    try {
      // if (form.getValues().OrgCode != null && form.getValues().OrgCode.length > 0) {
      //   let url = form.getValues().OrgCode
      //     .map((invCode: string) => `SubInvCode=${invCode}`)
      //     .join("&");
      //   if (url) {
      //     url = `?${url}`;
      //   }

      //   const response = await repositoryDelivery.get(
      //     `/api/v1/TblDmItemPosition/get-select${url}`
      //   );
      //   if (response && response.httpStatusCode === 200) {
      //     const transformedData = response.data
      //       .filter((i: any) => i.positionCode && i.positionName)
      //       .map((item: any) => ({
      //         value: item.positionCode,
      //         label: item.positionCode + " - " + item.positionName,
      //       }));
      //     setDataPositionCode(transformedData);
      //   }
      // } else {
      const response = await repositoryDelivery.get(
        `/api/v1/TblDmItemPosition/get-all`
      );
      if (response && response.httpStatusCode === 200) {
        const transformedData = response.data
          .filter((i: any) => i.positionCode && i.positionName)
          .map((item: any) => ({
            value: item.positionCode,
            text: item.positionCode + " - " + item.positionName,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value))
        ).map((value) =>
          transformedData.find((item: any) => item.value === value)
        );
        setDataPositionCode(uniqueData);
      }
      // }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  const fetchData = async (request: IServerSideGetRowsRequest) => {
    try {
      // Lấy page size hiện tại từ grid API
      const currentPageSize = gridRef.current?.api?.paginationGetPageSize() || paginationPageSize;
      const skip = request.startRow || 0;
      const take = currentPageSize;

      const keySearch = {
        KeySearch: form.getValues().KeySearch,
        startDate: form.getValues().startDate,
        endDate: form.getValues().LoaiKy === "NGAY" ? form.getValues().endDate : null,
        TimeType: form.getValues().LoaiKy === "NGAY" ? null :
          form.getValues().LoaiKy === "THANG" ? "month" :
            form.getValues().LoaiKy === "QUY" ? "quarter" :
              form.getValues().LoaiKy === "NAM" ? "year" : null,
      };

      let url = `/api/v1/SumInventory/get-sum-inv_balance-report?Skip=${skip}&Take=${take}`;
      // Xử lý BrandCode (hoặc BranchCode) là mảng
      if (form.getValues().OrgCode && Array.isArray(form.getValues().OrgCode)) {
        form.getValues().OrgCode.forEach((code: string) => {
          url += `&OrgCode=${encodeURIComponent(code)}`;
        });
      }
      if (form.getValues().SubInvCode && Array.isArray(form.getValues().SubInvCode)) {
        form.getValues().SubInvCode.forEach((code: string) => {
          url += `&SubInvCode=${encodeURIComponent(code)}`;
        });
      }
      // "LTAC0880;LTAU1016"
      // ItemCode: truyền dạng ; ngăn cách
      if (form.getValues().ItemCode && Array.isArray(form.getValues().ItemCode)) {
        form.getValues().ItemCode.forEach((code: string) => {
          url += `&ItemCode=${encodeURIComponent(code)}`;
        });
      }
      // Các param khác
      Object.entries(keySearch).forEach(([key, value]) => {
        if (key === "OrgCode" || key === "SubInvCode" || key === "ItemCode") return; // tránh lặp lại
        if (value) {
          url += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      // return await repositoryDelivery.get<MessageResponse<SumListSerialModel[]>>(url);
      return await repositoryDelivery.get(url);
    } catch (error) {
      console.error(error);
    } finally {
    }
  };



  //#region Download Image
  const handleDownloadImage = async (refCurrent: React.RefObject<HTMLDivElement>) => {
    const html2canvas = await import("html2canvas-pro");

    if (!refCurrent.current) {
      console.error("Error: refCurrent is null.");
      return;
    }

    // setIsLoading(true);
    open(); // Hiển thị loading

    try {
      // 🚀 TRICK 1: Pre-optimize DOM trước khi capture
      const element = refCurrent.current;

      // Set fixed size để html2canvas xử lý nhanh hơn
      const originalStyle = element.style.cssText;
      element.style.width = `${element.scrollWidth}px`;
      element.style.transform = "scale(1)";
      element.style.transformOrigin = "top left";

      // 🚀 TRICK 2: Hide unnecessary elements
      const unnecessaryElements = element.querySelectorAll(
        "button, .fa-solid, .fa-regular, svg",
      );
      const hiddenElements: HTMLElement[] = [];
      unnecessaryElements.forEach((el: any) => {
        if (el.style.display !== "none") {
          hiddenElements.push(el);
          el.style.display = "none";
        }
      });

      // 🚀 TRICK 3: Html2canvas với settings tối ưu tối đa
      const canvas = await html2canvas.default(element, {
        scale: 1, // 🔥 Key optimization: scale = 1
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#ffffff",
        width: element.scrollWidth,
        logging: false,
        imageTimeout: 1000, // 🔥 Giảm timeout
        removeContainer: false,
        foreignObjectRendering: false,
        ignoreElements: (element) => {
          // 🔥 Skip heavy elements
          return (
            element.tagName === "BUTTON" ||
            element.tagName === "SVG" ||
            element.classList.contains("fa-solid") ||
            element.classList.contains("fa-regular")
          );
        },
      });

      // 🚀 TRICK 4: Restore DOM ngay lập tức
      element.style.cssText = originalStyle;
      hiddenElements.forEach((el) => {
        el.style.display = "";
      });

      // 🚀 TRICK 5: Generate filename nhanh
      const now = new Date();
      const fileName = `Bieu-Do-Bao-Cao-Ton-Kho-Theo-Chi-Nhanh-Qua-Khu-${form.getValues().Tabs === "chartColumn" ? "hinh-Cot" : "hinh-Tron"}-${String(now.getDate()).padStart(2, "0")}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getHours()).padStart(2, "0")}-${String(now.getMinutes()).padStart(2, "0")}`;

      // 🚀 TRICK 6: Download trực tiếp bằng toBlob (nhanh nhất)
      canvas.toBlob(
        (blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${fileName}.jpg`;
            link.click();
            URL.revokeObjectURL(url);
            NotificationExtension.Success("Tải ảnh thành công!");
          }
        },
        "image/jpeg",
        0.85,
      );
    } catch (error) {
      console.error("Error generating image:", error);
      NotificationExtension.Fails("Tải ảnh thất bại!");
    } finally {
      // setIsLoading(false);
      close(); // Đóng loading
    }
  };

  // Call api bên server
  const getServerSideDatasource = useCallback((): IServerSideDatasource => {
    return {
      getRows: async (params) => {
        try {
          const response = (await fetchData(params.request)) || [];
          const allData = Array.isArray(response.data) ? response.data : [];
          // Map view -> field
          const mapViewToField: Record<string, string> = {
            soluong: "SlTonDauTong",
            giatri: "GtTonDauTong",
            soluong_cuoi: "SlTonCuoiTong",
            giatri_cuoi: "GtTonCuoiTong",
          };
          const view = form.getValues().view;
          const metricField = mapViewToField[view] || "SlTonCuoiTong";

          // Áp dụng sortModel từ ag-Grid (server-side) hoặc default sort khi đang hiển thị chart
          const sortModel: any[] = (params.request as any).sortModel || [];
          const primarySort = sortModel.length
            ? { colId: sortModel[0].colId, sort: sortModel[0].sort }
            : form.getValues().Tabs !== "table"
              ? { colId: metricField, sort: "desc" }
              : null;

          if (primarySort?.colId) {
            const col = primarySort.colId;
            const dir = primarySort.sort === "asc" ? 1 : -1;
            (allData as any[]).sort((a, b) => {
              const av = Number(a?.[col]) || 0;
              const bv = Number(b?.[col]) || 0;
              return dir * (av - bv);
            });
          }

          // Chuẩn bị dữ liệu cho chart dựa trên metricField (đã sắp xếp giống allData)
          interface ChartRow {
            branch: string;
            value: number;
            legend: string;
          }

          const chartRows: ChartRow[] = (allData as Array<any>).map((r) => {
            const branch = (r.OrgCode && String(r.OrgCode)) || (r.OrganizationId != null ? String(r.OrganizationId) : "Unknown");
            const value = Number(r?.[metricField]) || 0;
            return {
              branch,
              value,
              legend: `${branch} (${view && view.includes("giatri") ? formatPrice(value) : value})`,
            };
          });

          // Nếu đang hiển thị chart thì đảm bảo chart được sắp xếp giảm dần theo value
          if (form.getValues().Tabs === "chartColumn" || form.getValues().Tabs === "PieChart") {
            chartRows.sort((a, b) => b.value - a.value);
          }

          setChartData(chartRows);

          params.success({
            rowData: allData,
            rowCount: allData.length,
          });
          setLoading(false);
        } catch (error) {
          console.error("getRows error:", error);
          params.fail();
          setLoading(false);
        }
      },
    };
  }, [form.getValues().BranchCode, form.getValues().Tabs, form.getValues().view]);
  // Sau khi chọn tìm kiếm xong thì sẽ thực hiện click để call api này 
  const handleSearch = useCallback(() => {
    console.log("Search clicked with values:", form.getValues());
    setLoading(true);
    const api = gridRef.current?.api;
    if (!api) {
      console.log("API not ready");
      return;
    }

    // Refresh server-side cache để gọi lại getRows với filter mới
    (api as any).refreshServerSide({ purge: true });
  }, []);


  const onGridReady = useCallback((params: GridReadyEvent) => {
    // đăng datasource đúng để ag-Grid gọi getRows
    const datasource = getServerSideDatasource();
    datasourceRef.current = datasource;
    params.api.setGridOption('serverSideDatasource', datasource);
    console.log("Grid ready, datasource registered");
  }, [getServerSideDatasource]);

  const getRowId = useCallback((params: any) => {
    return params.data?.branchCode || Math.random().toString();
  }, []);

  const getRowStyle = useCallback((params: any) => {
    if (params.node.rowPinned) {
      return {
        backgroundColor: '#e7f5ff',
        fontWeight: 700,
        fontSize: '14px',
        borderTop: '3px solid #15aabf',
      };
    }
    return undefined;
  }, []);


  const [columnDefs] = useState<ColDef[]>([
    // { field: "OrganizationId", headerName: "Id chi nhánh" },
    { field: "OrgCode", headerName: "Mã chi nhánh" },
    { field: "ItemCode", headerName: "Mã sản phẩm" },
    {
      field: "SlTonDauTong", headerName: "Tổng số lượng đầu", sortable: true, width: 300,
    },
    {
      field: "GtTonDauTong", headerName: "Tổng Giá Trị Đầu", width: 300, sortable: true,
      valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
    },
    {
      field: "SlTonCuoiTong", headerName: "Tổng số lượng cuối", sortable: true, width: 300,
    },
    {
      field: "GtTonCuoiTong", headerName: "Tổng Giá Trị Cuối", width: 300, sortable: true,
      valueFormatter: (p) => (p.value != null ? formatPrice(p.value) : ""),
    },
  ]);

  const defaultColDef = useMemo<ColDef>(() => {
    return {
      sortable: true,
      resizable: true,
    };
  }, []);


  useEffect(() => {
    fetchBranchCode();
  }, [])

  useEffect(() => {
    fetchPositionCode();
  }, [form.getValues().OrgCode]);


  // Lấy dữ liệu mã sản phẩm
  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value))
        ).map((value) =>
          transformedData.find((item: any) => item.value === value)
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    if (value.length >= 3) {
      DataItemCode(value); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  const renderMultiSelectOption: MultiSelectProps["renderOption"] = ({
    option,
  }) => (
    <Group gap="sm">
      <Text>{dataItemCode.find((x) => x.value === option.value)?.label}</Text>
    </Group>
  );
  return (
    <Box pos={"relative"} style={containerStyle}>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
          overflowX: "hidden",
        }}
      >
        <Group justify="space-between">
          <BreadcrumbLayout1></BreadcrumbLayout1>
        </Group>
      </div>
      <Tabs value={form.getValues().Tabs} onChange={(value) => {
        form.setFieldValue("Tabs", value);
        setLoading(true);
        // reload data theo loại mới
        gridRef.current?.api?.refreshServerSide?.({ purge: true });
      }} >
        <Flex justify={"space-between"} style={{ marginBottom: 12 }}>
          <Group align="end" flex={"1"} wrap="wrap">
            <Grid style={{ width: "100%" }} mt={10}>
              <Grid.Col span={sizeGrid}>
                <Input placeholder="Từ khoá"
                  leftSection={<IconSearch color="#15aabf" />}
                  key={form.key("keySearch")}
                  {...form.getInputProps("KeySearch")}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: '#15aabf',
                      borderWidth: '2px',
                    }
                  }} />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  size="sm"
                  placeholder="Chọn loại kỳ"
                  leftSection={<IconCalendarStats size={20} color="#15aabf" />}
                  data={[
                    { value: "NGAY", label: "Ngày" },
                    { value: "THANG", label: "Tháng" },
                    { value: "QUY", label: "Quý" },
                    { value: "NAM", label: "Năm" },
                  ]}
                  {...form.getInputProps("LoaiKy")}
                  onChange={handleLoaiKyChange}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              {form.values.LoaiKy !== "NGAY" && (
                <>
                  <Grid.Col span={sizeGrid}>
                    <Select
                      size="sm"
                      placeholder={
                        form.values.LoaiKy === "THANG"
                          ? "Chọn tháng"
                          : form.values.LoaiKy === "QUY"
                            ? "Chọn quý"
                            : "Chọn năm"
                      }
                      leftSection={
                        <IconCalendarStats size={20} color="#15aabf" />
                      }
                      data={periodOptions}
                      value={selectedPeriod}
                      onChange={handlePeriodSelectChange}
                      styles={{
                        input: {
                          fontWeight: 600,
                          borderColor: "#15aabf",
                          borderWidth: "2px",
                        },
                      }}
                    />
                  </Grid.Col>
                  {form.values.LoaiKy !== "NAM" && (
                    <Grid.Col span={sizeGrid}>
                      <Select
                        size="sm"
                        placeholder="Chọn năm"
                        data={Array.from({ length: 5 }).map((_, i) => ({
                          value: String(currentYear - i),
                          label: `Năm ${String(currentYear - i)}`,
                        }))}
                        value={
                          form.getValues().Year
                            ? String(form.getValues().Year)
                            : String(currentYear)
                        }
                        onChange={(v) => handleYearChange(v)}
                        styles={{
                          input: {
                            fontWeight: 600,
                            borderColor: "#15aabf",
                            borderWidth: "2px",
                          },
                        }}
                      />
                    </Grid.Col>
                  )}
                </>
              )}

              <Grid.Col span={sizeGrid}>
                <DatePickerInput
                  value={
                    form.values.startDate ? new Date(form.values.startDate) : null
                  }
                  onChange={(d) =>
                    form.setFieldValue(
                      "startDate",
                      d ? d.toISOString().slice(0, 10) : null
                    )
                  }
                  placeholder="Từ ngày"
                  readOnly={form.values.LoaiKy !== "NGAY"}
                  clearable
                  size="sm"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              {form.values.LoaiKy === "NGAY" && (
                <Grid.Col span={sizeGrid}>
                  <DatePickerInput
                    value={
                      form.values.endDate ? new Date(form.values.endDate) : null
                    }
                    onChange={(d) =>
                      form.setFieldValue(
                        "endDate",
                        d ? d.toISOString().slice(0, 10) : null
                      )
                    }
                    placeholder="Đến ngày"
                    clearable
                    readOnly={form.values.LoaiKy !== "NGAY"}
                    size="sm"
                    locale="vi"
                    valueFormat="DD/MM/YYYY"
                    leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
                    styles={{
                      input: {
                        fontWeight: 600,
                        borderColor: "#15aabf",
                        borderWidth: "2px",
                      },
                    }}
                  />
                </Grid.Col>
              )}
              {form.getValues().Tabs !== "table" && (
                <Grid.Col span={sizeGrid}>
                  {/* Sắp xếp theo  */}
                  <Select
                    size="sm"
                    leftSection={<IconSortAscendingShapes color="#15aabf" />}
                    placeholder="Xem theo"
                    data={[
                      { value: "soluong", label: "Tổng số lượng đầu" },
                      { value: "giatri", label: "Tổng giá trị đầu" },
                      { value: "soluong_cuoi", label: "Tổng số lượng cuối" },
                      { value: "giatri_cuoi", label: "Tổng giá trị cuối" },
                    ]}
                    value={form.getValues().view}
                    onChange={(v) => {
                      form.setFieldValue("view", v);
                      const mapViewToCol: Record<string, string> = {
                        soluong: "SlTonDauTong",
                        giatri: "GtTonDauTong",
                        soluong_cuoi: "SlTonCuoiTong",
                        giatri_cuoi: "GtTonCuoiTong",
                      };
                      const colId = mapViewToCol[v ?? "soluong"] || "SlTonCuoiTong";
                      // chỉ set sort model (không đổi thứ tự cột)
                      gridRef.current?.api?.applyColumnState({
                        state: [{ colId, sort: "desc" }],
                        applyOrder: false,
                      });
                      // reload server-side để lấy dữ liệu đã sắp xếp
                      gridRef.current?.api?.refreshServerSide?.({
                        purge: true,
                      });
                    }}
                    styles={{
                      input: {
                        fontWeight: 600,
                        borderColor: "#15aabf",
                        borderWidth: "2px",
                      },
                    }}
                    defaultValue="soluong"
                    allowDeselect={false}
                  />
                </Grid.Col>
              )}
              <Grid.Col span={sizeGrid}>
                <MultiSelect size="sm"
                  leftSection={<IconBrandBootstrap color="#15aabf" />}
                  searchable
                  clearable
                  placeholder="Chọn chi nhánh"
                  data={dataBranchCode
                    .filter((ele) => ele.att2 && ele.text)
                    .map((ele) => ({
                      label: ele.att2 + " - " + ele.text,
                      value: ele.att2,
                    }))}
                  key={form.key("OrgCode")}
                  onChange={(value) => form.setFieldValue("OrgCode", value)}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: '#15aabf',
                      borderWidth: '2px',
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <MultiSelect
                  leftSection={<IconBuildingFactory color="#15aabf" />}
                  searchable
                  clearable
                  placeholder="Chọn vị trí kho"
                  data={dataPositionCode
                    .filter((i) => i.value && i.text)
                    .map((item) => ({
                      value: item.value,
                      label: item.text,
                    }))
                  }
                  key={form.key("SubInvCode")}
                  onChange={(value) => form.setFieldValue("SubInvCode", value)}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: '#15aabf',
                      borderWidth: '2px',
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <MultiSelect
                  size="sm"
                  placeholder="Nhập mã sản phẩm"
                  clearable
                  searchable
                  data={dataItemCode}
                  renderOption={renderMultiSelectOption}
                  value={form.getValues().ItemCode || []}
                  onSearchChange={(value) => {
                    debouncedDataItemCode(value); // Sử dụng debounce
                  }}
                  onChange={(v) => form.setFieldValue("ItemCode", v)}
                  leftSection={<IconBarcode size={20} color="#15aabf" />}
                  styles={{
                    input: {
                      fontWeight: 600,
                      borderColor: "#15aabf",
                      borderWidth: "2px",
                    },
                  }}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={20} />}
                  color="blue"
                  variant="filled"
                  onClick={handleSearch}
                  styles={{
                    root: {
                      fontWeight: 600,
                    }
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Group>
          <Group>
            <Tabs.List>
              {/* Biểu đồ hình cột */}
              <Tabs.Tab value="chartColumn" >
                <IconChartBar size={24} />
              </Tabs.Tab>
              {/* Biểu đồ hình tròn */}
              <Tabs.Tab value="PieChart" >
                <IconChartDonut3 size={24} />
              </Tabs.Tab>
              {/* table bình thường */}
              <Tabs.Tab value="table" >
                <IconTable size={24} />
              </Tabs.Tab>
            </Tabs.List>
          </Group>
        </Flex>
        <Tabs.Panel value="table" style={{ height: `${height}px !important` }}>
          <div
            // style={{ height: `650px` }} 
            style={gridStyle}
            className={"ag-theme-quartz"}>
            <AgGridReact<any>
              ref={gridRef}
              loading={loading}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowModelType={"serverSide"}
              pagination={true}
              paginationPageSize={100}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onGridReady={onGridReady}
              getRowId={getRowId}
              getRowStyle={getRowStyle}
              localeText={AG_GRID_LOCALE_VN}
            // pinnedBottomRowData={totalRow ? [totalRow] : []}
            />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value="PieChart" pt="xs" style={{ height: `${height + 700}px` }}>
          <Group justify="end" mt="md">
            <Button color="teal" onClick={() => handleDownloadImage(ChartPieRef)}>
              Tải ảnh biểu đồ tròn
            </Button>
          </Group>
          <div ref={ChartPieRef}
            style={{
              width: '100%',
            }}>
            {chartData && chartData.length > 0 ? (
              <AgCharts
                options={pieOptions}
                style={{ width: "100%", height: "750px" }}
              />
            ) : (
              <Box
                style={{
                  width: "100%",
                  height: "750px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #e9ecef",
                  color: "#666",
                }}
              >
                Không có dữ liệu
              </Box>
            )}
          </div>
        </Tabs.Panel>

        {/* Hiển thị dạng dạng cột nằm ngang  */}
        <Tabs.Panel
          value="chartColumn"
          //  style={{ height: `${height + 700}px` }}
          style={{ height: `auto` }}
        >
          <Group justify="end" mt="md">
            <Button color="teal" onClick={() => handleDownloadImage(ChartColumnRef)}>
              Tải ảnh biểu đồ cột
            </Button>
          </Group>
          <div
            ref={ChartColumnRef}
            style={{
              width: '100%',
            }}
          >
            {chartData && chartData.length > 0 ? (
              <AgCharts
                options={chartOptions}
                className="chart"
                style={{ width: "100%", height: `1400px`, overflowX: "hidden" }}
              />
            ) : (
              <Box
                style={{
                  width: "100%",
                  height: `750px`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px dashed #e9ecef",
                  color: "#666",
                }}
              >
                Không có dữ liệu
              </Box>
            )}
          </div>
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};
export default SumListSerialQKV2;
